<template>
  <div class='group-calendar'>
    <span class='calendar-title'>{{ yearMonth }}</span>
    <table class='com-table calendar'>
      <colgroup>
        <col style='width: 14.2%;'>
        <col style='width: 14.2%;'>
        <col style='width: 14.2%;'>
        <col style='width: 14.2%;'>
        <col style='width: 14.2%;'>
        <col style='width: 14.2%;'>
        <col style='width: 14.2%;'>
      </colgroup>
      <thead>
      <tr>
        <th>일</th>
        <th>월</th>
        <th>화</th>
        <th>수</th>
        <th>목</th>
        <th>금</th>
        <th>토</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for='(week, idx) in calendarDay' :key='idx'>
        <td v-for='(day, index) in week'
            :key='index' :class='{ disabled: isDisabled(day) }'>
          <template v-if='!isEmpty(day)'>
            <span class='num' :style="typeof day === 'string' ? 'color:red;' : ''">{{ day }}</span>
            <div class='check-line'>
              <div v-for='(lesson, index) in getDateLessons(day)' :key='index' class='com-check'>
                <input :id='`check-1-${lesson.date}-${lesson.tm}`' ref='checkLesson'
                       :checked='lesson.selected'
                       :disabled='lesson.disabled'
                       :style='`${lesson.disabled ? "color: lightgray":""}`'
                       name='check-1-1'
                       type='checkbox'
                       @change='(event)=>onChangeCheckLesson(event,lesson)'
                >

                <label
                    :for='`check-1-${lesson.date}-${lesson.tm}`'
                    :style='`${lesson.disabled ? "color: lightgray;text-decoration:line-through":""}`'>{{
                    lesson.tm
                  }}({{ lessonTime }})
                </label>
              </div>
            </div>
          </template>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment';
import api from '@/assets/js/api';
import {Utils} from '@/assets/js/utils';

export default {
  name: 'batchReserveTable',
  props: {
    seq: Number,
    leftCount: Number,
    yearMonth: String,
    targetTime: String,
    productId: [Number, String],
    staffId: {
      type: [Number, String],
      default: '',
    },
    reservationLimitDate: String,
    startDate: String,
    endDate: String,
    reservedScheduleIds: Array,
    reservedSchedules: {
      type: Array,
      default: [],
    },
    lessonCountType: String,
    lessonCount: Number,
    lessonTime: String
  },
  computed: {
    cId() {
      const {getters} = this.$store;
      return getters['auth/cId'];
    },
  },
  watch: {
    staffId() {
      this.init();// 재조회를 위한 함수 호출
    },
    targetTime() {
      this.init();// 재조회를 위한 함수 호출
      for (const c of this.$refs.checkLesson)
        c.checked = false;
    },
  },
  data() {
    return {
      calendarDay: [],
      centerId: '',
      selected: [],
      now: moment(),
      lesson: {},
      selectedLesson: [],
      holidays: [],
    };
  },
  mounted() {
    this.initCalendar();
    this.init();
  },
  methods: {
    // 휴일 구하기 함수..
    async getMonthHolidays(centerid, ym) {
      if (centerid !== 0) {
        await api.get(`/admin/api/center/${centerid}/holiday/${ym}`)
            .then((res) => {
              // 휴일을 배열로 넣기..
              this.holidays = [];
              for (const d of res.data) {
                this.holidays.push(d.holidayDate.split('-')[d.holidayDate.split('-').length - 1]);
              }
            })
            .catch((res) => {

            });
      }
    },
    async initCalendar() {
      this.centerId = this.cId; // 센터 Id
      const weekArr = [
        ['', '', '', '', '', '', ''],
        ['', '', '', '', '', '', ''],
        ['', '', '', '', '', '', ''],
        ['', '', '', '', '', '', ''],
        ['', '', '', '', '', '', ''],
        ['', '', '', '', '', '', ''],
        ['', '', '', '', '', '', ''],
      ];
      await this.getMonthHolidays(this.centerId, this.yearMonth);
      let weekNum = 0;
      for (let i = 1; i <= 31; i++) {
        const position = this.$moment(`${this.yearMonth}-${i}`).day();
        let string = ''
        if (this.holidays.length > 0) {
          for (let j = 0; j < this.holidays.length; j++) {
            if (i == this.holidays[j]) {
              if (this.holidays[j] < 10) {
                string = this.holidays[j].replace('0', '');
              } else {
                string = this.holidays[j];
              }
              break;
            } else {
              string = i;
            }
          }
        }

        weekArr[weekNum][position] = string || i;

        if (position == 6) {
          weekNum++;
        }
      }
      weekArr.forEach((element, index) => {
        if (element[0] == '' && element[6] == '') {
          weekArr.splice(index, 1);
        }
      });
      weekArr.forEach((element, index) => {
        if (element[0] == '' && element[6] == '') {
          weekArr.splice(index, 1);
        }
      });

      this.calendarDay = weekArr;
    },
    getDateLessons(day) {
      const date = this.getDateStringWithDay(day);
      if (Utils.isEmpty(this.lesson[date]) || !this.staffId) {
        return [];
      }
      return this.lesson[date];
    },
    isDisabled(day) {
      if (Utils.isEmpty(day)) {
        // 빈칸인 경우
        return false;
      }
      const dFormat = 'YYYY-MM-DD';
      const date = this.getDateStringWithDay(day);

      // 유효기간 이내가 아닐 경우
      if (moment(date, dFormat).isBefore(this.startDate)
          || moment(date, dFormat).isAfter(this.endDate)) {
        return true;
      }

      // 오늘 이후 날짜인 경우
      if (moment(date, dFormat).isSame(this.now) || moment(date, dFormat).isAfter(this.now)) {
        return false;
      }

      // 예약가능일부터 오늘 사이인 경우는 가능, 이외는 불가능
      return !Utils.isDateInRange(date, this.reservationLimitDate, this.now.format(dFormat));
    },
    getDateStringWithDay(day) {
      return `${this.yearMonth}-${day.toString().padStart(2, '0')}`;
    },
    async init() {
      if (this.targetTime === ':' || !this.staffId)
        return;
      try {

        const dFormat = 'YYYY-MM-DD';
        // const { data } = await this.onSearcList();

        let startMoment = moment(this.startDate);
        const ymMoment = moment(`${this.yearMonth}-01`);
        if (ymMoment.isAfter(startMoment)) {
          startMoment = ymMoment;
        }

        const endMoment = moment(this.endDate).add(1, 'days');
        let tmpMoment = startMoment.clone();
        let loopMoment = startMoment.clone();

        const data = [];

        // const targetMon = loopMoment.format('MM');
        for (let i = 0; i < 5; i += 1) {
          // eslint-disable-next-line no-await-in-loop
          const {data: da} = await api.get(`/admin/api/center/${this.centerId}/lesson/schedule/teacher/all?targetDate=${loopMoment.format('YYYYMMDD')}&staffIdList=${this.staffId}&lessonType=`);
          data.push(...da);
          loopMoment = loopMoment.add(1, 'week');

          if (loopMoment.isAfter(endMoment))
            break;
        }
        this.lesson = {};


        while (true) {
          const date = tmpMoment.format(dFormat);

          if (!endMoment.isAfter(tmpMoment))
            break;

          let disabled = false;
          for (const les of data) {
            const lesStartMoment = moment(`${les.lessonDate} ${les.lessonStartTime}`.split('+')[0]).subtract(1, 'minute');
            const lesEndMoment = moment(`${les.lessonDate} ${les.lessonEndTime}`.split('+')[0]).subtract(1, 'minute');
            const tmpTimeMoment = moment(`${tmpMoment.format('YYYY-MM-DD')} ${this.targetTime}:00`);


            if (tmpTimeMoment.clone().add(59, 'minute').isBetween(lesStartMoment, lesEndMoment) ||
                tmpTimeMoment.isBetween(lesStartMoment, lesEndMoment)) {
              console.log(lesStartMoment.format('YYYY-MM-DD HH:mm'), lesEndMoment.format('YYYY-MM-DD HH:mm'),
                  tmpTimeMoment.format('YYYY-MM-DD HH:mm'),
                  tmpTimeMoment.clone().add(59, 'minute').isBetween(lesStartMoment, lesEndMoment),
                  tmpTimeMoment.isBetween(lesStartMoment, lesEndMoment));
              // console.log("cancel", tmpMoment.format('YYYY-MM-DD HH:mm'))
              disabled = true;
            }
          }

          // const params = {
          //     centerCustomerId: this.$parent.centerCustomerId,
          //     centerLessonScheduleId: 0,
          //     lessonDate: date,
          //     startTime: this.targetTime,
          //     endTime: this.targetTime,
          // };

          // @스웨거 검색: 스케줄 시간 중복 체크
          // const { data: data1 } = await api.get(`/admin/api/center/${this.centerId}/lesson/schedule/duplicate/customer`, { params });
          // if (data1) {
          //     alert('뭐임');
          //     disabled = true;
          // }

          if (Utils.isEmpty(this.lesson[date])) {
            this.lesson[date] = [];
          }
          this.lesson[date].push({
            tm: this.targetTime,
            date,
            disabled,
            selected: false,
          });
          tmpMoment = tmpMoment.add(1, 'days');
        }

        // sort
        const dates = Object.keys(this.lesson);
        for (const d of dates) {
          this.lesson[d].sort((a, b) => (a.cls_less_start_tm < b.cls_less_start_tm ? -1 : 1));
        }
      } catch (error) {
        console.log(error);
        this.lesson = {};
      }
    },
    onSearcList() {
      // @스웨거: 상품의 월별(YYYYMM) 예약가능 스케줄 목록 조회
      return api.get(`/admin/api/center/${this.centerId}/lesson/schedule/product/year-month/`, {
        params: {
          centerProductId: this.productId,
          staffId: this.staffId, // no required
          yearMonth: moment(this.yearMonth).format('YYYYMM'),
        },
      });
    },
    format(date) {
      return moment(date).format('DD');
    },
    onChangeCheckLesson($event, les) {
      les.selected = $event.target.checked;

      const li = [];
      for (const lesArr of Object.values(this.lesson))
        for (const les1 of lesArr)
          if (les1.selected)
            li.push(les1);
      if (this.leftCount < li.length) {
        alert('남은 횟수보다 체크를 더 할 수 없습니다.');
        $event.target.checked = false;
        les.selected = false;
        return;
      }
      this.$emit('update:set', les.selected, li, this.yearMonth, () => {
        $event.target.checked = false;
        les.selected = false;
      });

    },
    isEmpty(v) {
      return Utils.isEmpty(v);
    },
    resetSelected() { // 초기화 함수
      this.selected = [];
      this.selectedLesson = [];

      if (Utils.isEmpty(this.$refs.checkLesson)) {
        return false;
      }

      for (const r of this.$refs.checkLesson) {
        const idx = this.reservedScheduleIds.indexOf(r.value);
        if (idx === -1) {
          r.checked = false;
        }
      }
    },
    arrangeCheckLessons(scheduleId) {
      const checkLessons = this.$refs.checkLesson;

      if (!checkLessons) return;

      for (const checkLesson of checkLessons) {
        if (checkLesson.value === scheduleId) {
          console.log('수업 횟수가 초과되었습니다.');
          checkLesson.checked = false;
          this.selectedLesson.pop();
          this.selected.pop();
        }
      }
    },
    // 해당 수업이 예약된 스케줄인지를 판정하는 함수
    isReservedSchedule(lesson) {
      // if (this.reservedScheduleIds.indexOf(lesson.cls_center_less_schd_id) !== -1) {
      //     const schedule = this.reservedSchedules.find(schedule => schedule.cls_center_less_schd_id === lesson.cls_center_less_schd_id);
      //
      //     if (!schedule) {
      //         alert('해당되는 스케줄이 존재하지 않습니다.');
      //         return false;
      //     }
      //
      //     return schedule.clsc_resv_status_cd === 'RR' || schedule.clsc_resv_status_cd === 'CR';
      // }

      return false;
    },
  },
};
</script>
<style lang='scss' scoped>
</style>
